<template>
  <div>
    <div class="process">
        <div class="item" v-for="(item,i) in list" v-bind:key="i" @click="gotoother(item.route)">
          <div class="bg">
          <div class="con">
            <div class="tit">{{item.tit}}</div>
            <div class="txt">{{item.txt}}</div>
          </div>
          </div>
          <div class="ico">{{item.num}}</div>
        </div>
    </div>
    <!-- <footbottom></footbottom> -->
  </div>
</template>

<script>
  import footbottom from '@/footer'
  export default{
    components:{
      footbottom
    },
    data() {
      return{
        list:[
          {num:'01',tit:'丰巢寄件',txt:'',route:{name:'parcel'}},
          {num:'02',tit:'数据对接',txt:'【我的寄件查看寄件信息】'},
          {num:'03',tit:'门店收件',txt:''},
          {num:'04',tit:'收件通知',txt:''},
          {num:'05',tit:'订单',txt:'【待支付】',route:{name:'myorder',query:{status:0}}},
          {num:'06',tit:'确认订单',txt:'【支付】',route:{name:'myorder',query:{status:0}}},
          {num:'07',tit:'订单',txt:'【完成洗衣】',route:{name:'myorder',query:{status:0}}},
          {num:'08',tit:'待取件',txt:'【取件确认】',route:{name:'myorder',query:{status:0}}},
          {num:'09',tit:'订单',txt:'【待评价】',route:{name:'myorder',query:{status:0}}},
          {num:'10',tit:'待评价',txt:'【评价操作】',route:{name:'myorder',query:{status:0}}},
        ]
      }
    },
    methods:{
      gotoother(route){
        if(route){
          this.$router.push(route)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/process.vue